import { Component, OnInit, Input, HostBinding, OnDestroy } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Colors } from '../../models/enums/colors.enum';
import { ComponentWidth } from '../../models/enums/component-width.enum';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-column',
  host: {
    '[class.grow]' : 'grow'
  },
  templateUrl: './column.component.html',
  styleUrls: ['./column.component.scss']
})
export class ColumnComponent implements OnInit, OnDestroy {
  @Input() align: string;
  @Input() horizontalAlign: string;
  @Input() background: string;
  @Input() height: string;
  @Input() width: string;
  @Input() padding: string;
  @Input() grow: boolean;
  @Input() margin: string = "10px 0 0 0";
  componentWidths = ComponentWidth;

  @HostBinding('class.xs') xs: boolean = true;
  @HostBinding('class.s') s : boolean = false;
  @HostBinding('class.m') m : boolean = false;
  @HostBinding('class.l') l: boolean = false;

  subscription: ISubscription;

  //Optionally, if you add the system, then the background will display
  //as red if the status is false
  @Input() systemId: string;
  @Input() subSystemId: string = null;

  constructor(private http: HttpService) { }

  ngOnInit() {
    if(this.systemId){
      this.subscription = this.http.dashboardData().subscribe(data => {
        let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
        if (filtered.length > 0){
          if (filtered[0].status == false){
            this.background = Colors.red;
          }
        }
      })
    }

    this.xs = this.width == ComponentWidth.extraSmallColumn;
    this.s = this.width == ComponentWidth.smallColumn;
    this.m = this.width == ComponentWidth.mediumColumn;
    this.l = this.width == ComponentWidth.largeColumn;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/column/column.component.ts